module.exports = __webpack_public_path__ + "static/media/profile-pic-120.b1b2413f.svg";